<template>
  <div class="market">
    <div class="market-main">
      <div class="market-top">
        <div class="search-wrap">
          <van-search
            class="search"
            v-model="searchValue"
            placeholder="请输入商品或机构名称"
            @clear="onSearch"
          >
          </van-search>
          <div class="search-btn" @click="onSearch">搜索</div>
        </div>
        <div class="market-manual">
          <span>商品列表</span>
          <span @click="comDown">
            <img src="@/assets/手册@4x.png" alt="" />
            操作手册</span
          >
        </div>
      </div>

      <div class="goods_list">
        <div class="goods_list_sidebar">
          <van-sidebar v-model="tabActive" @change="tabChange" color="#0070FF">
            <van-sidebar-item
              v-for="(item, i) in tab"
              :key="i"
              :title="item.name"
            />
          </van-sidebar>
        </div>
        <div class="goods_list_discussion">
          <van-checkbox v-model="checked" icon-size="16px" @change="getList(1)"
            >只看服务券商品</van-checkbox
          >
          <van-list
            class="list-van"
            v-if="listShow"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <listCom v-for="item in list" :key="item.id" :item="item"></listCom>
          </van-list>
          <van-empty
            v-if="!listShow"
            class="custom-image"
            :image="require('../../../../assets/coupons-none.png')"
            description="暂无数据"
          />
        </div>
      </div>
    </div>
    <van-image-preview
      v-model="dialogVisible"
      :showIndex="false"
      :onClose="
        () => {
          dialogVisible = false
        }
      "
      :images="[exhibitImg]"
    />

    <van-popup v-model="pdfShow" position="bottom" :style="{ height: '80%' }">
      <preview-pdf :pdfUrl="coliText1"></preview-pdf>
    </van-popup>
  </div>
</template>
<script>
import { getLocalStorage } from '@utils'
import listCom from './list'
import { checkStatus } from '@api/intermediary/index'
import { goodsTypeInfo, entPage, getOperation } from '@api/market/index'
import { Toast } from 'vant'
import previewPdf from './previewPDF'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  components: {
    listCom,
    previewPdf
  },
  data() {
    return {
      pdfShow: false,
      dialogVisible: false,
      exhibitImg: '',
      status: 0, // 认证状态
      searchValue: '', // 搜索内容
      progressShow: true,
      progress: [
        {
          icon: require('../../../../assets/cs-icon1.png'),
          tab: '选择',
          text: '选择商品\n下单'
        },
        {
          icon: require('../../../../assets/cs-icon2.png'),
          tab: '沟通',
          text: '线下和机构\n沟通'
        },
        {
          icon: require('../../../../assets/cs-icon3.png'),
          tab: '确认',
          text: '在线确认\n订单金额'
        },
        {
          icon: require('../../../../assets/cs-icon4.png'),
          tab: '评价',
          text: '评价商品'
        }
      ],
      tabActive: 0,
      sidebarActive: 0,
      tab: [],
      tabId: '',
      list: [],
      listShow: true,
      loading: true,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      checked: '',
      isCharng: false,
      coliText1: null,
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  watch: {
    async '$route.query.type'(val) {
      this.isCharng = true
      this.getstatus(1)
      await this.getGoodsTypeList()
      await this.getList(1)
    }
  },
  async mounted() {
    this.getstatus(1)
    await this.getGoodsTypeList()
    await this.getList(1)
    await this.getOperation()
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    getOperation() {
      return new Promise(resolve => {
        getOperation().then(res => {
          this.coliText1 = res.data.data[0].uploadUrl
          resolve()
        })
      })
    },
    // 模板下载
    comDown(val) {
      this.buriedPoint()
      if (
        this.isImageOrPdfType(this.coliText1, ['jpg', 'png', 'jpeg', 'gif'])
      ) {
        this.dialogVisible = true
        this.exhibitImg = this.coliText1
        return
      }
      if (this.isImageOrPdfType(this.coliText1, ['pdf', 'PDF'])) {
        this.pdfShow = true
        return
      }
      let ua = navigator.userAgent
      let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(ua)
      if (this.coliText1) {
        // let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
        if (isiOS) {
          this.$copyText(this.coliText1).then(res => {
            Toast('复制链接成功，请前往浏览器打开链接下载文件！')
          })
        } else {
          window.open(this.coliText1)
        }
      } else {
        Toast('暂无文件可查看！')
      }
    },
    // 通过文件后缀名，判断是否是图片
    isImageOrPdfType(url, includesTypeList) {
      const urlSuffixType = url.split('.')
      const urlType = urlSuffixType[urlSuffixType.length - 1]
      const type = includesTypeList.includes(urlType.toLowerCase())
      return type
    },
    // 获取认证状态 同时判断角色权限 userType是否是法人或经办人 0-否 1-是
    getstatus(type) {
      checkStatus({ organizationType: type }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          const isAuth = data[0].userType === 1
          this.status = data[0].status
          this.$store.commit('market/setHasAuth', isAuth)
        } else {
          Toast(msg)
        }
      })
    },
    // 获取商品类型
    getGoodsTypeList() {
      return new Promise((resolve, reject) => {
        goodsTypeInfo().then(res => {
          const { code, data, msg } = res.data
          if (code == '0000') {
            this.tab = [
              {
                ids: '',
                name: '全部'
              },
              ...data
            ]
            // 从别的地方跳转 中介超市返显原来的服务类型
            const type = this.$route.query.type
            if (type) {
              if (type === '通用') {
                this.tabId = ''
                this.tabActive = 0
              } else {
                this.tab.map((item, index) => {
                  if (item.name === type) {
                    this.tabId = item.ids
                    this.tabActive = index
                  }
                })
              }
            }
          } else {
            Toast(msg)
          }
          resolve()
        })
      })
    },
    onSearch() {
      this.getList(1)
    },
    getList(num) {
      if (num) {
        this.pageNum = 1
        this.list = []
        this.loading = true
        this.finished = false
        this.listShow = true
      }
      const params = {
        integer: this.checked ? 1 : '',
        useCoupon: this.checked ? 1 : '',
        key: this.searchValue,
        goodsTypeIds: this.tabId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      return new Promise((resolve, reject) => {
        entPage(params).then(res => {
          const { code, data, msg } = res.data
          if (code === '0000') {
            data.list.forEach(item => {
              this.list.push(item)
            })
            this.list = this.list.map(item => {
              return {
                ...item,
                oraimg: item.img.ossUrl
              }
            })
            this.loading = false
            if (data.list.length < this.pageSize) {
              this.finished = true
            } else {
              this.finished = false
            }
            if (this.list.length == 0) {
              this.listShow = false
            } else {
              this.listShow = true
            }
          } else {
            Toast(msg)
          }
          resolve()
        })
      })
    },
    tabChange(e) {
      if (this.isCharng) {
        this.isCharng = false
        return
      }
      this.tabId = this.tab[e].ids
      this.getList(1)
    },
    onLoad() {
      this.pageNum++
      this.getList()
    },
    statusTap() {
      this.$router.push({
        // path: '/coupons/form?status=' + this.status
        path: '/intermediary/index'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.market {
  width: 100%;
  min-height: calc(100vh - 94px);
  background: #f7f7f7;
}
.market-main {
  height: calc(100vh - 94px);
  position: relative;
  z-index: 10;
  .market-top {
    width: 100%;
    height: 120px;
    background: url('~@/assets/images/背景@4x.png') no-repeat;
    background-size: 100% 100%;
  }
  .search-wrap {
    display: flex;
    align-items: stretch;
    padding: 15px;
    .van-search {
      flex: 1;
      padding: 0;
      box-sizing: border-box;
      background: none;
      .van-search__content {
        background: #fff;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border: none;
      }
    }
    .search-btn {
      font-size: 14px;
      color: #333;
      background: #fff;
      padding: 0 15px;
      display: flex;
      align-items: center;
      margin-left: -4px;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      border-left: 1px solid #eee;
    }
  }
  .market-manual {
    margin-top: 15px;
    padding: 0 15px;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > span:nth-child(2) {
      font-size: 14px;
    }
    img {
      width: 16px;
      vertical-align: middle;
    }
  }
  .tab-wrap {
    padding: 15px 0 0;
  }
  .list-van {
    // padding: 0 5% 50px 10px;
    // height: 470px;
    // width: 254px;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: scroll;
  }
  .goods_list {
    display: flex;
    height: calc(100% - 124px);
    overflow: auto;
  }
  .goods_list_sidebar {
    width: 110px;
    height: 100%;
    overflow: auto;
  }
  .goods_list_discussion {
    width: calc(100% - 110px);
    height: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    background: #f8f9fc;
    overflow: auto;
    /deep/ .van-checkbox__label {
      color: #0080ff;
    }
    /deep/ .van-checkbox__icon .van-icon {
      border: 1px solid #0080ff;
    }
  }
}
.custom-image {
  margin-top: 10%;
  /deep/.van-empty__image {
    width: 200px;
    height: 120px;
    margin: auto 30px;
  }
  /deep/.van-empty__description {
    margin-top: -36px;
  }
}
/deep/ .van-checkbox {
  width: 60%;
  margin: 10px 0 0 70px;
  // float: right;
  border-radius: 20px;
  padding: 6px 10px;
  background: #e8f4ff;
}
/deep/ .van-checkbox__label {
  font-size: 16px;
}
/deep/.van-sidebar {
  width: 100%;
  // height: 400px;
  overflow: auto;
}
/deep/.van-sidebar-item {
  padding: 5px;
  color: #333;
  text-align: center;
  height: 50px;
  line-height: 50px;
}
/deep/.van-sidebar-item--select::before {
  width: 0;
  height: 0;
}
</style>
